export default "__VITE_PUBLIC_ASSET__1a0ae43a__"